<template>
<Row :gutter="20">
  <Col :span="12">
    <Card><div id="statusConsist"></div></Card>
  </Col>
  <Col :span="12">
    <Card><div id="randomStatusConsist"></div></Card>
  </Col>
</Row>
</template>

<script>
import echarts from 'echarts'
import { ListSubjectConsist } from '@/api/stat'

export default {
  name: 'subject-consist',
  data: function () {
    return {
      height: '160px',
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c} ({d}%)'
      }
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init: function () {
      const id = this.$route.params.id
      ListSubjectConsist(id).then(async res => {
        this.drawConsist('statusConsist', '受试者状态', res.status)
        this.drawConsist('randomStatusConsist', '入组受试者状态', res.randomStatus)
      })
    },
    drawConsist: function (id, title, res) {
      var opts = {
        width: 'auto',
        height: '320px'
      }
      this.echarts = echarts.init(document.getElementById(id), 'light', opts)
      var options = {
        title: {
          text: title + '构成',
          x: 'center'
        },
        tooltip: this.tooltip,
        legend: {
          orient: 'vertical',
          left: 'left',
          data: res.statuses
        },
        series: {
          name: title,
          type: 'pie',
          radius: '72%',
          data: res.series
        }
      }
      this.echarts.setOption(options)
    }
  }
}
</script>
